<template>
  <div class="send-protocol-form">
    <div class="form-container" v-if="state === 'form'">
      <form v-if="!webView" class="text-field-container" @submit.prevent="onSubmit">
        <input
          class="email-field"
          name="input-1"
          :placeholder="t('transcript_placeholder')"
          :disabled="isSent"
          v-model="emailValue"
          @input="onEmailChange"
        />
      </form>
      <input
        class="email-field"
        v-if="webView"
        name="email"
        v-model="emailValue"
        autocomplete="email"
        :disabled="isSent"
        :title="t('transcript_placeholder')"
        @input="onEmailChange"
      />
    </div>
  </div>
</template>

<script>
import { useI36n } from '@jota-one/i36n/src/index.vue2'
import { mapGetters } from 'vuex'
import { ref } from '@vue/composition-api'

export default {
  name: 'SendProtocolForm',
  props: {
    email: {
      type: String,
      default: ''
    },
    isSent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('uistate', ['webView']),
    state: {
      get () {
        return this.$store.state.uistate.transcriptState
      },
      set (value) {
        this.$store.commit('uistate/SET_TRANSCRIPT_STATE', value)
      }
    }
  },
  setup (props, { emit }) {
    const { $label: t } = useI36n()
    const emailValue = ref(props.email)

    const onEmailChange = () => {
      emit('onEmailChange', emailValue.value)
    }

    return {
      emailValue,
      onEmailChange,
      t
    }
  }
}
</script>

<style lang="postcss" scoped>
.email-field {
  margin-top: 20px;
  width: 100%;
  background-color: #f3f2f0;
  height: 50px;
  border-radius: 0;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom-width: 2px;
  padding-top: 20px;
  padding-left: 10px;
  flex-grow: 1 !important;
  font-size: 16px;
  outline: none;
}
.email-field::placeholder {
  line-height: 1.33;
  font-size: 15px;
  height: 20px;
}
.send-protocol-form {
  .form-container {
    background-color: white;
    padding: 10px;
    margin-left: 15px;
    margin-right: 15px;
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;
    position: relative;
    align-items: center;
    p {
      color: #a2a4a5;
    }
  }
}
</style>
